<template>
  <div class="calibrator-container" :style="style"
    @mousedown="onMouseDown"
    @mouseup="onMouseUp"
    >
    <div v-for="h in handles" :key="h"
      :class="['handle', 'handle-' + h]"
      @mousedown.stop.prevent="handleDown(h)"
    ></div>
    <div class="description">{{ unit.defaultNumber }}{{ unit.name }}</div>
    <div class="done" @click="$emit('done')">
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Calibrator',
  props: {
    unit: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dragging: false,
      resizing: false,
      resizingHandle: null,

      mouseOffset: {},

      handles: ['mr', 'ml'],

      x: 600,
      y: 300,
      w: 100,
      h: 30
    }
  },
  mounted() {
    document.addEventListener('mousemove', this.moving)
    document.addEventListener('mouseup', this.onMouseUp)
    this.w = this.calibrationValue*this.unit.defaultNumber
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.moving)
    document.removeEventListener('mouseup', this.onMouseUp)
  },
  methods: {
    onMouseDown(e) {
      this.dragging = true
      this.mouseOffset.x = this.x - e.pageX
      this.mouseOffset.y = this.y - e.pageY
    },
    onMouseUp() {
      this.dragging = false
      this.resizing = false
      this.resizingHandle = null
    },
    moving(e) {
      if(this.dragging) {
        this.x = e.pageX+this.mouseOffset.x 
        this.y =  e.pageY+this.mouseOffset.y
        return
      }
      if(this.resizing) {
        let x = this.x
        let y = this.y
        let w = this.w
        let h = this.h

        switch (this.resizingHandle) {
          case 'tl':
            w = w + x - e.pageX
            x = e.pageX
            h = h + y - e.pageY
            y = e.pageY
            break
          case 'tm':
            h = h + y - e.pageY
            y = e.pageY
            break
          case 'tr':
            w = e.pageX - x
            h = h + y - e.pageY
            y = e.pageY
            break
          case 'mr':
            w = e.pageX - x
            break 
          case 'br':
            w = e.pageX - x
            h = e.pageY - y 
            break;
          case 'bm':
            h = e.pageY - y
            break
          case 'bl':
            w = w + x - e.pageX
            x = e.pageX
            h = e.pageY - y
            break
          case 'ml':
            w = w + x - e.pageX
            x = e.pageX
            break
        }
        this.x = x
        this.y = y
        this.h = h
        this.w = w

        const newCalibrationValue = Math.round(w/this.unit.defaultNumber)/this.backgroundImageWidth
        this.$store.commit('mutate', {prop: 'percentBackgroundWidthPerUnit', value: newCalibrationValue })

        return
      }
    },
    handleDown(h) {
      this.resizing = true
      this.resizingHandle = h
    },
  },
  computed: {
    backgroundImageWidth() {
      return this.$store.getters.backgroundImage.width
    },
    calibrationValue() {
      return this.$store.getters.pixelPerUnit
    },
    style() {
      return {
        position: 'absolute',
        top: this.y + 'px',
        left: this.x + 'px',
        width: this.w + 'px',
        height: this.h + 'px',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';
.calibrator-container {
  background-color: $red;
  color: white;
  line-height: 30px;
  font-weight: 500;
  cursor: move;
  z-index: 1000;

  .description {
    max-height: 100%;
    overflow: hidden;
  }
}
.handle {
  box-sizing: border-box;
  position: absolute;
  width: 10px;
  height: 10px;
  background: #EEE;
  border: 1px solid #333;
  z-index: 2;
}
.handle-ml {
  top: calc(50% - 5px);
  left: -10px;
  cursor: w-resize;
}
.handle-mr {
  top: calc(50% - 5px);
  right: -10px;
  cursor: e-resize;
}
.done {
  position: absolute;
  bottom: -40px;
  height: 30px;
  left: calc(50% - 15px);
  color: $green;
  background-color: white;
  border-radius: 15px;
  opacity: 0.5;
  cursor: pointer;
  transition: 0.1s all;

  &:hover {
    opacity: 1;
  }
}
</style>